import {
  GET_SINGLE_FEATURE_ERROR,
  GET_SINGLE_FEATURE_START,
  GET_SINGLE_FEATURE_SUCCESS,
} from 'constants/action-types/settings/singleFeature';
import apiAction from 'helpers/apiAction';

export default id => dispatch =>
  dispatch(
    apiAction({
      url: `/settings/${id}`,
      method: 'GET',
      API_REQUEST_START: GET_SINGLE_FEATURE_START,
      API_REQUEST_SUCCESS: GET_SINGLE_FEATURE_SUCCESS,
      API_REQUEST_FAILURE: GET_SINGLE_FEATURE_ERROR,
      onSuccess: payload => {
        dispatch({
          type: GET_SINGLE_FEATURE_SUCCESS,
          payload,
        });
      },
      onEnd: () => false,
    }),
  );
